// extracted by mini-css-extract-plugin
export default {"joiningContainer":"StatusJoinCall__joiningContainer--kE4S3","joiningContent":"StatusJoinCall__joiningContent--WO3jF"};